/** Default block list to capture. Edit freely in the app — names become CLI profile names. */
export const DEFAULT_BLOCK_NAMES: string[] = [
  "campus",
  "campus-block-a",
  "campus-block-b",
  "campus-block-c",
  "campus-block-d",
  "campus-block-e",
  "campus-block-f",
  "campus-block-g",
];

export const STORAGE_KEY = "attenducsi-capture.v1";

/** Reject names that would not be valid CLI profile names. */
export const PROFILE_NAME_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9._-]*$/;

/** Characters allowed in a CLI profile name. */
export const ALLOWED_NAME_CHARS = /[^a-zA-Z0-9._-]/g;